import { useEffect, useLayoutEffect, useState } from "react";
import { useImmer } from "use-immer";
import toast from "react-hot-toast";
import {
  APP_BASE_URL,
  GET_CUSTOMER_GROUP_LIST,
  GET_FORMS_LIST,
  GET_SCHEDULE_CODE_LIST,
  JOINT_INSPECION_ASSIGNMENT_API,
} from "../../../Common/EndPoints";
import "./AssignmentForm.scss";

import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { Autocomplete, Button, Checkbox, FormControlLabel, FormGroup, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useGetDeviceTypesQuery } from "../../../features/SearchFilters/searchFiltersSlice";
import { extractAllowedUserRoleList } from "../../../Utils/Utils";
import { periodicityOptions } from "./AssignmentForm";
import Loader from "../../Loader/Loader";
import ConfirmationModal from "../../../Modal/ConfirmationModal";

let LabelProps = {
  InputLabelProps: {
    shrink: true,
  },
};

let initialConfirmationModal = {
  open: false,
  message: "",
  des: "",
};

const initialDropDowns = {
  scheduleCodes_DD: [],
  customerGroups_DD: [],
  userRoles_DD: [],
  formList_DD: [],
  gearTypes_DD: [],
};

let stateUrlObj = {
  customerGroups_DD: GET_CUSTOMER_GROUP_LIST,
  formList_DD: GET_FORMS_LIST,
};

function hasDropdownCurrentValue(ddList: any[], ddValue: any) {
  let hasValue = false;
  ddList.forEach((dd) => {
    if (dd.key === ddValue?.key) {
      hasValue = true;
    }
  });
  return hasValue;
}

function JointInspectionAssignmentForm() {
  const location: any = useLocation();
  const navigate = useNavigate();

  const { data: gearTypesList = [] } = useGetDeviceTypesQuery(null);
  const [filteredFormList, setFilterdFormList] = useState([]);

  const [confirmationModal, setConfirmationModal] = useImmer(initialConfirmationModal);
  const [loader, setLoader] = useState(false);

  const { handleSubmit, control, watch, setValue, reset, getValues } = useForm({
    defaultValues: {
      startDate: null,
      scheduleCodes: null,
      maintenanceFormIdPrimary: null,
      maintenanceFormIdSecoundary: null,
      userRoleIdPrimary: null,
      userRoleIdSecoundary: null,
      stationGroup: null,
    } as any,
  });

  const scheduleCodes = watch("scheduleCodes");
  const gearType = watch("gearType");
  const userRoleIdPrimary = watch("userRoleIdPrimary");
  const userRoleIdSecoundary = watch("userRoleIdSecoundary");
  const periodicity = watch("periodicity");
  const maintenanceFormIdPrimary = watch("maintenanceFormIdPrimary");
  const maintenanceFormIdSecoundary = watch("maintenanceFormIdSecoundary");
  const startDate = watch("startDate");
  const stationGroup = watch("stationGroup");
  const active = watch("active");

  let USER_ID = localStorage.getItem("userId");

  const [dropDowns, setDropDowns] = useImmer(initialDropDowns);

  useEffect(() => {
    Object.entries(stateUrlObj).forEach(([state, url]) => {
      setDropDownValues(state, url);
    });
    getUserRoleList();
  }, []);

  const getUserRoleList = () => {
    let roleHierarchies = JSON.parse(localStorage.getItem("roleHierarchies") || "{}");
    let allowedRoleIdList = extractAllowedUserRoleList(roleHierarchies);
    setDropDowns((prev: any) => {
      prev.userRoles_DD = allowedRoleIdList;
    });
  };

  useEffect(() => {
    if (dropDowns.scheduleCodes_DD && scheduleCodes) {
      if (!hasDropdownCurrentValue(dropDowns.scheduleCodes_DD, scheduleCodes)) {
        setValue("scheduleCodes", null);
      }
    }
  }, [dropDowns.scheduleCodes_DD]);

  useLayoutEffect(() => {
    if (location.state) {
      reset({
        ...(location.state || {}),
        periodicity: periodicityOptions.find((val: any) => val.key === location.state.periodicity),
      });
      getScheduleCode(location.state.gearType.id);
    }
  }, [location]);

  // useEffect(() => {
  //   setFilterdFormList(dropDowns.formList_DD);
  // }, [dropDowns.formList_DD]);

  useEffect(() => {
    if (gearType) {
      let gear = gearType.value.toUpperCase();
      let newFormList = dropDowns.formList_DD.filter((val: any) => val.value.toUpperCase().includes(gear));
      setFilterdFormList(newFormList);
    } else {
      setFilterdFormList([]);
    }
  }, [gearType, dropDowns.formList_DD]);

  const setDropDownValues = (state: any, url: any) => {
    let getUrl = `${APP_BASE_URL}${url}`;
    axios.get(getUrl).then((res: any) => {
      let RESPONSE = res.data.data;
      let ddList = Object.entries(RESPONSE).map(([key, value]) => {
        return { key: key, value: value };
      });
      setDropDowns((prev: any) => {
        prev[state] = ddList;
      });
    });
  };

  const handleFormSubmit = (formData: any) => {
    const params = {
      createdBy: USER_ID,
      customerGroupId: formData.stationGroup.key,
      dueOffset: Number(formData.dueAssignment),
      upcomingOffset: Number(formData.dueAssignment) + 1,
      periodicity: Number(formData.periodicity.key),
      scheduleCodeId: formData.scheduleCodes.key,
      startedDt: new Date(formData.startDate).getTime(),
      active: formData.active ? true : false,
      maintenanceFormIdPrimary: formData.maintenanceFormIdPrimary.key,
      maintenanceFormIdSecoundary: formData.maintenanceFormIdSecoundary.key,
      userRoleIdPrimary: formData.userRoleIdPrimary.id,
      userRoleIdSecoundary: formData.userRoleIdSecoundary.id,
    };

    let crudStatus = {
      success: "created successfully",
      error: "failed to create",
    };
    let url = `${APP_BASE_URL}${JOINT_INSPECION_ASSIGNMENT_API}`;
    let apiRequest = axios.post;
    if (location.state) {
      crudStatus = {
        success: "updated successfully",
        error: "failed to update",
      };
      let jointInspectionId = location.state.jointInspectionId;
      url = `${APP_BASE_URL}${JOINT_INSPECION_ASSIGNMENT_API}/${jointInspectionId}`;
      apiRequest = axios.put;
    }
    setLoader(true);
    apiRequest(url, null, { params })
      .then((res) => {
        toast.success(crudStatus.success);
      })
      .catch((err) => {
        const errMsg = err?.response?.data?.error?.message;
        toast.error(errMsg);
      })
      .finally(() => {
        setLoader(false);
        navigate("/form-assignment");
      });
  };

  const getScheduleCode = (typeId: any) => {
    let url = `${APP_BASE_URL}${GET_SCHEDULE_CODE_LIST}`;
    let params = {
      deviceTypeId: typeId,
      scheduleCodeMapingOnly: true,
    };
    axios
      .get(url, { params })
      .then((res: any) => {
        let RESPONSE = res.data.data;
        let ddList = RESPONSE.map((val: any, i: any) => {
          return { key: val.id, value: val.code };
        });

        setDropDowns((prev: any) => {
          prev.scheduleCodes_DD = ddList ?? [];
        });
      })
      .catch((err) => {
        setDropDowns((prev) => {
          prev.scheduleCodes_DD = [];
        });
      });
  };

  const onSubmit = (data: any) => {
    let periodicity = Number(data.periodicity.key);
    let dueOffset = Number(data.dueAssignment);
    if (dueOffset > periodicity) {
      toast.error("Due Assignment should be less than Peridiocity");
    } else {
      setConfirmationModal((prev) => {
        prev.open = true;
        prev.message = "Form Assignment";
        prev.des = "Do you want to create form assignment?";
      });
    }
  };

  return (
    <>
      {loader && <Loader />}

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-page">
          <div className="form-section">
            <div className="part-header">Assignment Info</div>
            <div className="form-part">
              <Controller
                control={control}
                name="gearType"
                rules={{ required: "Asset Type is required" }}
                render={({ field: { onChange, onBlur, ref, name }, fieldState: { invalid, error } }) => {
                  return (
                    <Autocomplete
                      disablePortal
                      className="field"
                      onBlur={onBlur}
                      options={gearTypesList}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      ref={ref}
                      value={gearTypesList.find((item: any) => item.id === gearType?.id) || null}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name={name}
                          label="Asset Type *"
                          error={invalid}
                          helperText={error?.message}
                        />
                      )}
                      getOptionLabel={(params) => params.value}
                      onChange={(_event, newValue) => {
                        onChange(newValue);
                        setValue("scheduleCodes", null);
                        getScheduleCode(newValue?.id ?? null);
                      }}
                    />
                  );
                }}
              />

              <Controller
                control={control}
                name="scheduleCodes"
                rules={{ required: "Schedule Code is required" }}
                render={({ field: { onChange, onBlur, ref, name }, fieldState: { invalid, error } }) => {
                  return (
                    <Autocomplete
                      disablePortal
                      className="field"
                      options={dropDowns.scheduleCodes_DD}
                      isOptionEqualToValue={(option: any, value: any) => option.key === value.key}
                      value={dropDowns.scheduleCodes_DD?.find((val: any) => val.key === scheduleCodes?.key) || null}
                      onBlur={onBlur}
                      ref={ref}
                      sx={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name={name}
                          label="Select Schedule Codes *"
                          error={invalid}
                          helperText={error?.message}
                        />
                      )}
                      getOptionLabel={(params) => params.value}
                      onChange={(_event, newValue) => {
                        onChange(newValue);
                      }}
                    />
                  );
                }}
              />

              <Controller
                control={control}
                name="maintenanceFormIdPrimary"
                rules={{ required: "Primary Form is required" }}
                render={({ field: { onChange, onBlur, ref, name }, fieldState: { invalid, error } }) => {
                  return (
                    <Autocomplete
                      disablePortal
                      className="field"
                      options={filteredFormList}
                      onBlur={onBlur}
                      ref={ref}
                      isOptionEqualToValue={(option: any, value: any) => option.key === value.key}
                      value={filteredFormList?.find((val: any) => val.key === maintenanceFormIdPrimary?.key) || null}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name={name}
                          label="Select Primary Form*"
                          error={invalid}
                          helperText={error?.message}
                        />
                      )}
                      getOptionLabel={(params) => params.value}
                      onChange={(_event, newValue) => {
                        onChange(newValue);
                      }}
                    />
                  );
                }}
              />

              <Controller
                control={control}
                name="maintenanceFormIdSecoundary"
                rules={{ required: "Secondary Form is required" }}
                render={({ field: { onChange, onBlur, ref, name }, fieldState: { invalid, error } }) => (
                  <Autocomplete
                    disablePortal
                    className="field"
                    onBlur={onBlur}
                    ref={ref}
                    isOptionEqualToValue={(option: any, value: any) => option.key === value.key}
                    value={filteredFormList?.find((val: any) => val.key === maintenanceFormIdSecoundary?.key) || null}
                    options={filteredFormList}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Secondary Form*"
                        name={name}
                        error={invalid}
                        helperText={error?.message}
                      />
                    )}
                    getOptionLabel={(params) => params.value}
                    onChange={(_event, newValue) => {
                      onChange(newValue, "maintenanceFormIdSecoundary");
                    }}
                  />
                )}
              />

              <Controller
                control={control}
                name="stationGroup"
                rules={{ required: "Station Group is required" }}
                render={({ field: { onChange, onBlur, ref, name }, fieldState: { invalid, error } }) => {
                  return (
                    <Autocomplete
                      disablePortal
                      onBlur={onBlur}
                      ref={ref}
                      className="field"
                      isOptionEqualToValue={(option: any, value: any) => option.key === value.key}
                      value={dropDowns.customerGroups_DD?.find((val: any) => val.key === stationGroup?.key) || null}
                      options={dropDowns.customerGroups_DD}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Station Group *"
                          name={name}
                          error={invalid}
                          helperText={error?.message}
                        />
                      )}
                      getOptionLabel={(params) => params.value}
                      onChange={(_event, newValue) => {
                        onChange(newValue);
                      }}
                    />
                  );
                }}
              />

              <Controller
                control={control}
                name="userRoleIdPrimary"
                rules={{ required: "Primary Role is required" }}
                render={({ field: { onChange, onBlur, ref, name }, fieldState: { invalid, error } }) => {
                  return (
                    <Autocomplete
                      disablePortal
                      onBlur={onBlur}
                      ref={ref}
                      className="field"
                      options={dropDowns.userRoles_DD}
                      isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                      value={dropDowns.userRoles_DD?.find((val: any) => val.id === userRoleIdPrimary?.id) || null}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Primary Role*"
                          name={name}
                          error={invalid}
                          helperText={error?.message}
                        />
                      )}
                      getOptionLabel={(params) => params.value}
                      onChange={(_event, newValue) => {
                        onChange(newValue);
                      }}
                    />
                  );
                }}
              />

              <Controller
                control={control}
                name="userRoleIdSecoundary"
                rules={{ required: "Secondary Role is required" }}
                render={({ field: { onChange, onBlur, ref, name }, fieldState: { invalid, error } }) => (
                  <Autocomplete
                    disablePortal
                    onBlur={onBlur}
                    ref={ref}
                    className="field"
                    options={dropDowns.userRoles_DD}
                    isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                    value={dropDowns.userRoles_DD?.find((val: any) => val.id === userRoleIdSecoundary?.id) || null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Secondary Role*"
                        name={name}
                        error={invalid}
                        helperText={error?.message}
                      />
                    )}
                    getOptionLabel={(params) => params.value}
                    onChange={(_event, newValue) => {
                      onChange(newValue);
                    }}
                  />
                )}
              />
            </div>
          </div>
          <hr className="horizontal-rule"></hr>
          <div className="form-section">
            <div className="part-header">Timelines</div>
            <div className="form-part">
              <Controller
                control={control}
                name="periodicity"
                rules={{ required: "Periodicity is required" }}
                render={({ field: { onChange, onBlur, ref, name }, fieldState: { invalid, error } }) => {
                  return (
                    <Autocomplete
                      disablePortal
                      onBlur={onBlur}
                      ref={ref}
                      className="field"
                      options={periodicityOptions}
                      isOptionEqualToValue={(option, value) => option.key === value.key}
                      value={periodicityOptions.find((val: any) => val.key === periodicity?.key) || null}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Periodicity *"
                          name={name}
                          error={invalid}
                          helperText={error?.message}
                        />
                      )}
                      getOptionLabel={(params) => params.value}
                      onChange={(_event, newValue) => {
                        onChange(newValue);
                      }}
                    />
                  );
                }}
              />

              <Controller
                control={control}
                name="dueAssignment"
                rules={{ required: "Due Assignment is required" }}
                render={({ field: { onChange, onBlur, ref, value, name }, fieldState: { invalid, error } }) => (
                  <TextField
                    name={name}
                    onBlur={onBlur}
                    ref={ref}
                    className="field"
                    onChange={(e) => {
                      if (Number(e.target.value) >= 0) onChange(e.target.value, "dueAssignment");
                    }}
                    type="number"
                    {...LabelProps}
                    value={value ?? 0}
                    label="Due assignment *"
                    placeholder="Enter Due assignment"
                    error={invalid}
                    helperText={error?.message}
                  />
                )}
              />

              <Controller
                control={control}
                name="startDate"
                rules={{ required: "Start Date is required" }}
                render={({ field: { onChange, onBlur, ref, value, name }, fieldState: { invalid, error } }) => {
                  return (
                    <TextField
                      name={name}
                      className="field"
                      onBlur={onBlur}
                      ref={ref}
                      onChange={(e) => {
                        onChange(e.target.value);
                      }}
                      type="date"
                      value={startDate || null}
                      label="Start From *"
                      placeholder="Enter Start Date"
                      {...LabelProps}
                      error={invalid}
                      helperText={error?.message}
                    />
                  );
                }}
              />
            </div>
          </div>

          <div className="footer">
            <Controller
              control={control}
              name="active"
              render={({ field: { onChange, onBlur, ref, name } }) => (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onBlur={onBlur}
                        ref={ref}
                        name={name}
                        checked={active || null}
                        onChange={(e) => onChange(e.target.checked)}
                      />
                    }
                    label="Start Schedule"
                  />
                </FormGroup>
              )}
            />

            <Button variant="contained" type="submit">
              {location.state ? "Update Assignment" : "Assign"}
            </Button>
          </div>
        </div>
      </form>
      {confirmationModal && (
        <ConfirmationModal
          open={confirmationModal.open}
          loading={loader}
          onClose={() => {
            setConfirmationModal(initialConfirmationModal);
          }}
          onAction={(confirmation: boolean) => {
            if (confirmation) {
              const formValue = getValues();
              handleFormSubmit(formValue);
            }
            setConfirmationModal(initialConfirmationModal);
          }}
          message={confirmationModal.message}
          des={confirmationModal.des}
        />
      )}
    </>
  );
}

export default JointInspectionAssignmentForm;
